setTimeout(()=>{
  console.log("youtube.com/@podcastshindistory");
});

window.addEventListener("close", function () {
    sessionStorage.removeItem('birchPreloaderCounter');
});



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".gallery-pic").forEach(function (pic) {
        pic.addEventListener("click", function () {
            const imgSrc = this.querySelector("img").getAttribute("src");
            const modalImage = document.querySelector(".image-modal img");
            modalImage.setAttribute("src", imgSrc);

            document.getElementById("modalOverlay").style.display = "block";
        });
    });

    document.querySelectorAll(".close-icon").forEach(function (icon) {
        icon.addEventListener("click", function () {
            document.getElementById("modalOverlay").style.display = "none";
        });
    });

    document.getElementById("modalOverlay").addEventListener("click", function (event) {
        if (!event.target.closest(".modal-box")) {
            this.style.display = "none";
        }
    });
});


$(document).ready(function(){
  var getImg = $('#image_for_palettes').attr('src');
  $('.tab-same .tab-items:nth-child(2)').find('img').attr('src',getImg);


  var getFirstActiveTab = $('.tab-pane.active .product-grid .product-item').find('img').attr('src');
  $('.tab-same .tab-items:nth-child(1)').find('img').attr('src',getFirstActiveTab);
});




  $(document).on('click', '.slideshow-banner__content a[data-tag]', function(){
    var gettag = $(this).attr('data-tag');
    $('ul.active-color-main li[data-tab='+gettag+']').trigger('click');
  });



var htmlcode = `<img loading="lazy" class="orderClass" height="1" width="699" src="https://cdn.shopify.com/s/files/1/0702/1707/2789/files/New_Project_4.png?v=1755620182">`;
$(document).ready(function(){
  setTimeout(()=>{
    $('#courses-app .courses-page').append(htmlcode);
  },900)
})